import { render, staticRenderFns } from "./UserInfoRegist.vue?vue&type=template&id=30865788"
import script from "./UserInfoRegist.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfoRegist.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports